import { FormlyFieldConfig } from 'ng-formly';
export const picklistFields: Array<FormlyFieldConfig> = [
    {
        key: 'name',
        type: 'input-field',
        className: 'col-md-2',
        templateOptions: {
            type: 'text',
            placeholder: 'Unique Name',
            required: true,
            label: 'Name'
        }
    },
    {
        key: 'label',
        type: 'input-field',
        className: 'col-md-2',
        templateOptions: {
            type: 'text',
            placeholder: 'Label',
            required: true,
            label: 'Label'
        }
    },
    {
        key: 'description',
        type: 'input-field',
        className: 'col-md-8',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Description'
        }
    },
    {
        type: 'repeatedsection',
        key: 'options',
        className: 'col-md-12',
        fieldArray: {
            className: 'row',
            templateOptions: {
                btnText: 'Add',
                label: 'Picklist Items'
            },
            fieldGroup: [
                {
                    key: "label",
                    className: 'col-md-3',
                    type: 'input-field',
                    templateOptions: {
                        type: 'text',
                        placeholder: "",
                        required: true,
                        label: "Label"
                    }
                },
                {
                    key: "value",
                    className: 'col-md-3',
                    type: 'input-field',
                    templateOptions: {
                        type: 'text',
                        placeholder: "",
                        required: true,
                        label: "Value"
                    }
                },
            ]
        }
    }
];


// WEBPACK FOOTER //
// ./src/app/shared/formfields/picklist.ts